export enum CustomRule {
  onlyCustom = 'C',
  onlyNotCustom = 'N',
  both = 'B',
}
